/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import EmptyLayout from '@/views/layouts/EmptyLayout.vue';
import Dashboard from '@/modules/core/home/views/Dashboard.vue';
import Filemanager from '@/modules/core/files/views/MainView.vue';
import CheckSuperUserPermission from '@/modules/renter/common/helpers/featureFlags';

export default [
    {
        path: 'dashboard',
        name: 'dashboard',
        meta: { auth: true },
        component: Dashboard
    },
    {
        // Konto użytkownika
        path: 'account',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            {
                path: 'profile',
                name: 'core-account-profile',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/account/views/Profile.vue')
            },
            {
                path: 'password',
                name: 'core-account-password',
                meta: { auth: true, stop: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/account/views/Password.vue')
            },
            {
                path: 'notifications',
                name: 'core-account-notifications',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/account/views/Notifications.vue')
            },
            {
                path: 'devices',
                name: 'core-account-devices',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/account/views/Devices.vue')
            },
            {
                path: 'pats',
                name: 'core-pats',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/pat/views/PatView.vue')
            }
        ]
    },
    {
        path: 'app',
        redirect: '/error/404',
        component: EmptyLayout,
        children: [
            // Użytkownicy
            {
                path: 'users/add',
                name: 'core-users-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/users/views/UserForm.vue')
            },
            {
                path: 'users/:publicId',
                name: 'core-users-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/users/views/UserForm.vue')
            },
            {
                path: 'users/:filterName(\\w+)?/:filterValue(\\d+)?',
                name: 'core-users',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/users/views/UsersList.vue')
            },
            // Role
            {
                path: 'roles',
                name: 'core-roles',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/roles/views/RolesList.vue'),
                beforeEnter: () => CheckSuperUserPermission()
            },
            {
                path: 'roles/add',
                name: 'core-roles-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/roles/views/RoleForm.vue'),
                beforeEnter: () => CheckSuperUserPermission()
            },
            {
                path: 'roles/:id(\\d+)',
                name: 'core-roles-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/roles/views/RoleForm.vue'),
                beforeEnter: () => CheckSuperUserPermission()
            },
            // Zespoły
            {
                path: 'teams',
                name: 'core-teams',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/teams/views/TeamsList.vue')
            },
            {
                path: 'teams/add',
                name: 'core-teams-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/teams/views/TeamForm.vue')
            },
            {
                path: 'teams/:id(\\d+)',
                name: 'core-teams-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/teams/views/TeamForm.vue')
            },
            // Organizacja
            {
                path: 'units',
                name: 'core-units',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/organization/views/UnitsList.vue'),
                children: [
                    {
                        path: 'add',
                        props: true,
                        name: 'core-units-add',
                        meta: { auth: true },
                        component: () => import(/* webpackChunkName: "core" */ '@/modules/core/organization/views/UnitForm.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        props: true,
                        name: 'core-units-edit',
                        meta: { auth: true },
                        component: () => import(/* webpackChunkName: "core" */ '@/modules/core/organization/views/UnitForm.vue')
                    }
                ]
            },
            // Zastępstwa
            {
                path: 'substitutions/add',
                name: 'core-substitutions-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/substitutions/views/SubstitutionForm.vue')
            },
            {
                path: 'substitutions/:id(\\d+)',
                name: 'core-substitutions-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/substitutions/views/SubstitutionForm.vue')
            },
            {
                path: 'substitutions/:filterName(\\w+)?/:filterValue(\\d+)?',
                name: 'core-substitutions',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/substitutions/views/SubstitutionList.vue')
            },
            // Źródła danych
            {
                path: 'data-sources',
                name: 'core-datasources',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/data-sources/views/DataSourcesList.vue')
            },
            {
                path: 'data-sources/add',
                name: 'core-datasources-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/data-sources/views/DataSourceForm.vue')
            },
            {
                path: 'data-sources/:id(\\d+)',
                name: 'core-datasources-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/data-sources/views/DataSourceForm.vue')
            },
            // Bezpieczeństwo
            {
                path: 'security',
                name: 'core-security',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/security/views/MainForm.vue')
            },
            // Poczta
            {
                path: 'mailing',
                name: 'core-mailing',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/mailing/views/MainForm.vue')
            },
            // Formularze
            {
                path: 'forms',
                name: 'core-forms',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/forms/views/FormsList.vue')
            },
            {
                path: 'forms/add',
                name: 'core-forms-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/forms/views/FormsForm.vue')
            },
            {
                path: 'forms/:id(\\d+)',
                name: 'core-forms-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/forms/views/FormsForm.vue')
            },
            // Powiadomienia
            {
                path: 'notifications/templates',
                name: 'core-notifications-templates',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/notifications/views/NotificationTemplatesList.vue')
            },
            {
                path: 'notifications/templates/add',
                name: 'core-notifications-templates-add',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/notifications/views/NotificationTemplateForm.vue')
            },
            {
                path: 'notifications/templates/edit/:id',
                name: 'core-notifications-templates-edit',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/notifications/views/NotificationTemplateForm.vue')
            },
            // Historia logowania
            {
                path: 'monitoring/authlog',
                name: 'core-authlog',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/authlog/views/AuthlogList.vue')
            },
            // Rejestr zmian
            {
                path: 'monitoring/changelog/:trailId(\\d+)?',
                name: 'core-changelog',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/changelog/views/ChangesList.vue')
            },
            {
                path: 'monitoring/changelog/diff/:id(\\d+)?',
                name: 'core-changelog-diff',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/changelog/views/ChangesView.vue')
            },
            // Harmonogram zadań
            {
                path: 'monitoring/scheduler',
                name: 'core-scheduler',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/scheduler/views/JobsList.vue')
            },
            {
                path: 'monitoring/scheduler/history/:type',
                name: 'core-scheduler-history',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/scheduler/views/JobHistory.vue')
            },
            {
                path: 'monitoring/scheduler/details/:type/:id',
                name: 'core-scheduler-details',
                meta: { auth: true },
                props: true,
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/scheduler/views/JobDetails.vue')
            },
            // Monitor kolejki zadań
            {
                path: 'monitoring/queues',
                name: 'core-queues',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/queues/views/MessageHistory.vue')
            },
            {
                path: 'monitoring/queues/details/:type/:id',
                name: 'core-queues-details',
                meta: { auth: true },
                component: () => import(/* webpackChunkName: "core" */ '@/modules/core/queues/views/MessageDetails.vue')
            }
        ]
    },
    {
        path: 'filemanager',
        name: 'filemanager',
        meta: { auth: true },
        component: Filemanager
    },
    {
        path: 'trash',
        name: 'trash',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "core" */ '@/modules/core/trash/views/TrashList.vue')
    }
];
